import React from "react";
import {
  useGetDriversQuery,
  useAssignTripDriverMutation,
} from "../store/api/driversApi";
import { useGetOrdersQuery } from "../store/api/adminApi";
import { useToast } from "./Toast";

export default function TripDriverAssignment({ order }) {
  const { data, error } = useGetDriversQuery();
  const { data: orders } = useGetOrdersQuery();
  const [assign, { isLoading }] = useAssignTripDriverMutation();
  const toast = useToast();
  const current = orders?.data?.find((trip) => trip.id === order.id) || order;
  const drivers = data?.data || [];
  return (
    <div>
      <label htmlFor="trip-driver" className="text-sm font-bold">
        Assigned driver
      </label>
      <select
        id="trip-driver"
        className="w-full border rounded-lg p-2 mt-2"
        value={current.driverId || ""}
        disabled={isLoading || !!error || !data}
        onChange={async (event) => {
          try {
            await assign({
              id: order.id,
              driverId: event.target.value || null,
            }).unwrap();
            toast.success("Driver assignment updated.");
          } catch {
            toast.error("Could not update driver assignment.");
          }
        }}
      >
        <option value="">No driver assigned</option>
        {current.driverId &&
          !drivers.some((driver) => driver.id === current.driverId) && (
            <option value={current.driverId}>Unavailable driver</option>
          )}
        {drivers
          .filter(
            (driver) =>
              driver.isActive !== false || driver.id === current.driverId,
          )
          .map((driver) => (
            <option
              key={driver.id}
              value={driver.id}
              disabled={driver.isActive === false}
            >
              {driver.name} · {driver.vehicle || driver.email}
              {driver.isActive === false ? " (disabled)" : ""}
            </option>
          ))}
      </select>
      {!!error && <p role="alert">Could not load drivers.</p>}
    </div>
  );
}
